import React from "react"
import MetricCard from "./MetricCard"
import SimpleTable, { Column, Header } from "../SimpleTable"
import Statistic from "../Statistic"

type SimpleMetricCardProps<H extends Header[]> = {
	title?: string
	content?: string
	value?: string
	legend?: string
	headers: H
	data: Column<H>[]
}

const SimpleMetricCard = <H extends Header[]>(
	props: SimpleMetricCardProps<H>
) => {
	const { title, content, value, legend, headers, data } = props

	return (
		<MetricCard
			title={title}
			content={content}
			chart={<Statistic valueRender={() => value} description={legend} />}
			details={<SimpleTable headers={headers} data={data} />}
		/>
	)
}

export default SimpleMetricCard
